import axios from 'axios'
import { appConfig } from '../config'

/**
 * GET /api/projects/{versionId} — full DT project detail including findings.
 */
export const fetchDtProjectDetail = async (token, versionId) => {
  const id = String(versionId || '').trim()
  if (!id) throw new Error('versionId is required')

  const res = await axios.get(
    `${appConfig.apiURL}/api/projects/${encodeURIComponent(id)}`,
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return res?.data && typeof res.data === 'object' ? res.data : null
}

/**
 * Fetch many project details with a small concurrency limit.
 * Failed ids are omitted from the map (caller can detect missing keys).
 */
export const fetchDtProjectDetails = async (token, versionIds = [], {
  concurrency = 4,
  onProgress = null
} = {}) => {
  const ids = [...new Set(
    (Array.isArray(versionIds) ? versionIds : [])
      .map((id) => String(id || '').trim())
      .filter(Boolean)
  )]
  const byId = {}
  let done = 0

  const worker = async (queue) => {
    while (queue.length) {
      const versionId = queue.shift()
      try {
        const detail = await fetchDtProjectDetail(token, versionId)
        if (detail) byId[versionId] = detail
      } catch (_) {
        // leave missing — export builder shows a stub
      }
      done += 1
      if (typeof onProgress === 'function') onProgress({ done, total: ids.length })
    }
  }

  const queue = ids.slice()
  const workers = Array.from(
    { length: Math.min(concurrency, Math.max(queue.length, 1)) },
    () => worker(queue)
  )
  await Promise.all(workers)
  return byId
}
